// @flow

export const FETCH_ORGANIZATIONS_PARAMS = {
  permission: ['cart:commit'],
};
